module.exports = __webpack_public_path__ + "2d3d980a7c7f15143ab93097bc1daf9c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/containers/Camps/camps-intro.jpg
// module id = 569
// module chunks = 0